import { actions as collection } from '@/plugins/Collection'

export default collection.toOptions({
  infrequently: 'Infrequently',
  frequently: 'Frequently',
  often: 'Often'
})
